<template lang="pug">
div(v-if="currentStep.data")
	lessonHeader
	stepTitle
	v-layout(row wrap)
		v-flex.card-image(xs6)
			div.image-container-card
				imageLoader
		v-flex.card00.flex(xs6)
			div.title-pre Mi presupuesto mensual
			v-spacer.py-2
			div.textindic Agrega tu ingreso fijo promedio mensual.
			v-spacer.py-5
			label.label-pre Ingreso fijo
			v-layout(row wrap)
				v-flex(xs10)
					v-text-field(placeholder="000.00" v-model="currentStep.data.budget" @keyup="format" prefix="$")
				v-flex(xs2)
					div.next(:class="{active:currentStep.data.budget}" @click="next")
						font-awesome-icon(icon="arrow-right")
			v-spacer.py-5
			div.totaltext TOTAL DE INGRESOS MENSUALES
			div.total {{currentStep.data.budget | toCurrency}}.00
	v-spacer.py-2
	el-button.b-calculate(type="success" :disabled="true") Calcular mi presupuesto
	lessonFooter
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import lessonHeader from "@/components/lesson-header/lesson-header";
import stepTitle from '@/components/step-title/step-title'
import expenses from '@/components/expenses/expenses'
import lessonFooter from "@/components/lesson-footer/lesson-footer";
import imageLoader from "@/components/image-loader/image-loader";
import {currencyFormat} from "@/utils/utils";

export default {
  name: 'Presupuesto',
  components:{
	lessonHeader,    
	stepTitle,           
    lessonFooter,
    imageLoader
  },
  computed: {
    ...mapGetters(['currentStep'])   
  },
  methods: {    
	...mapActions(['nextStepSCORM']),
	format (value) {						
      	this.currentStep.data.budget = currencyFormat(this.currentStep.data.budget);
	},
	next() {
		this.currentStep.transition = 'none';
		this.nextStepSCORM({transition:'none'});
	}
  }
}
</script>

<style scoped>
@import 'presupuesto.scss';
</style>